import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
  useRef,
  useContext,
  useCallback,
} from "react";
import { PubSub } from "aws-amplify";
import classNames from "classnames";
import { Link } from "react-router-dom";
import Icons from "../../utils/components/icons";
import DropDown from "../../utils/components/common/dropdown/dropdown";
import EmptyScreen from "../../utils/components/common/EmptyScreen/EmptyScreen";
import { backendConfig } from "../../config/BackendConfig";
import {
  roundToTwoDec,
  formatDateTime,
  round5,
  round5ForCatridge,
  valueFinderByModes,
  modeChecker,
} from "../../utils/utils";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../layouts/MainLayout";

import "./listView.scss";
import ModalComponent from "../../utils/components/common/modalComponent/ModalComponent";
import { USER_ROLES } from "../../utils/constants/userConstants";
import {
  DEVICE_MODES,
  getModeValue,
} from "../../utils/constants/deviceConstants";

const ListView = (
  {
    list,
    sortCallBack,
    modeList,
    sorting = [],
    handleLoading,
    id,
    searchText,
    isFilterApplied,
    removeAllFilters,
    isLoading,
    schedulerDeviceList,
  },
  ref
) => {
  const offlineMode = [{ label: "Offline", value: "OFFLINE" }];
  const { userCognitoData, loggedInUserRole, appTheme } =
    useContext(UserContext);

  const sortLabel = {
    asc: "Ascending sort",
    desc: "Descending sort",
    "": "No sort",
  };

  const [columList, setColumList] = useState([
    { key: "DeviceIcon", label: "", val: "", clickCount: 0 },
    { key: "DeviceName", label: "Name", val: "asc", clickCount: 1 },
    { key: "DeviceLocation", label: "Location", val: "", clickCount: 0 },
    { key: "clo2Value", label: "PPB", val: "", clickCount: 0 },
    { key: "cartridgeLevel", label: "Cartridge (%)", val: "", clickCount: 0 },
    { key: "temperature", label: "Temp (\u00b0C)", val: "", clickCount: 0 },
    { key: "humidity", label: "Humidity (%)", val: "", clickCount: 0 },
    { key: "timeStamp", label: "Last updated", val: "", clickCount: 0 },
    { key: "", label: "", val: "", clickCount: 0 },
    { key: "", label: "", val: "", clickCount: 0 },
    { key: "mode", label: "Mode", val: "", clickCount: 0 },
  ]);
  const [isDeviceModeErrorModal, setIsDeviceModeErrorModal] = useState(false);
  const { t } = useTranslation("dashboard");

  const changeModeSub = useRef(null);

  let changeModeLoadingTimeout = null;

  const cancelChangeModeLoading = () => {
    setIsDeviceModeErrorModal(true);
    handleLoading(false);
  };

  const setChangeModeLoading = () => {
    clearTimeout(changeModeLoadingTimeout);
    handleLoading(true);
    changeModeLoadingTimeout = setTimeout(cancelChangeModeLoading, 15000);
  };

  useImperativeHandle(ref, () => ({
    getSortList: () => columList,
  }));

  const getDeviceLocation = (dLocation) => {
    const deviceLocation = dLocation.split("#");
    const formatedLocation = deviceLocation.slice(-3);
    // const indexOfB = deviceLocation.findIndex(item => item === 'B');
    // deviceLocation.forEach((item, index) => {
    //     if(index >= indexOfB && (index%2) > 0){
    //         formatedLocation.push(item);
    //     }
    // });
    return formatedLocation.join(", ");
  };

  const changeDeviceModeMQTT = async (val, item) => {
    try {
      setChangeModeLoading();

      if (changeModeSub.current) {
        await changeModeSub.current.unsubscribe();
      }

      changeModeSub.current = PubSub.subscribe(
        "chorus/" +
          backendConfig.PUBSUB_ENV +
          "/things/" +
          item.DeviceUUID +
          "/state/events"
      ).subscribe({
        next: (data) => handleChangeModeSub(data, val, item),
        error: (error) => console.error(error),
        close: () => console.log(""),
      });

      await PubSub.publish(
        "chorus/" +
          backendConfig.PUBSUB_ENV +
          "/things/" +
          item.DeviceUUID +
          "/control/commands",
        {
          deviceName: item.DeviceUUID,
          data: {
            deviceTargetMode: val,
            RequestedUserID: userCognitoData.username,
          },
          eventType: "command",
        }
      );
    } catch (error) {
      // console.log(error);
      clearTimeout(changeModeLoadingTimeout);
      handleLoading(false);
      setIsDeviceModeErrorModal(true);
    }
  };

  const getPPBColor = (mode, ppb, target) => {
    const maxRange = Math.round((target + target * (30 / 100)) * 100) / 100;
    const maxRange2 = Math.round((target + target * (50 / 100)) * 100) / 100;

    if (modeChecker(mode)) {
      return appTheme === "light" ? "#3c3c3c" : "#FFFFFF";
    } else {
      return ppb <= maxRange
        ? "#07D95A"
        : ppb <= maxRange2
        ? "#FFD012"
        : "#FF2B02";
    }
  };

  const cartridgeColor = (level, mode) => {
    const roundedLevel = round5(level);

    if (mode === "OFFLINE") {
      return appTheme === "light" ? "#3C3C3C" : "#FFFFFF";
    } else {
      if (roundedLevel < 10) {
        return "#FF2B02";
      } else if (roundedLevel < 20) {
        return "#FFD012";
      } else {
        return "#07D95A";
      }
    }
  };

  const applySorting = (key, val) => {
    let sortColumnIndex = columList.findIndex((item) => item.key === key);
    let listCopy = [...columList];

    if (listCopy[sortColumnIndex].clickCount === 2) {
      listCopy[sortColumnIndex].clickCount = 0;
      listCopy[sortColumnIndex].val = "";
    } else {
      listCopy[sortColumnIndex].clickCount =
        listCopy[sortColumnIndex].clickCount + 1;
      listCopy[sortColumnIndex].val =
        listCopy[sortColumnIndex].clickCount === 1 ? "asc" : "desc";
    }

    // listCopy[sortColumnIndex].val = val;
    setColumList(listCopy);
    sortCallBack([...listCopy]);
  };

  const handleChangeModeSub = (data, localModeChangeVal, item) => {
    clearTimeout(changeModeLoadingTimeout);
    handleLoading(false);
    let changedModeVal = data?.value?.data?.mode;
    if (changedModeVal) {
      item.mode = getModeValue(changedModeVal);
    } else {
      setIsDeviceModeErrorModal(true);
    }
  };

  useEffect(() => {
    if (sorting.length > 0) {
      const column = [...columList];
      sorting.forEach((elem) => {
        const index = column.findIndex((itm) => itm.key === elem.key);
        column[index] = { ...column[index], ...elem };
      });
      setColumList(column);
    }

    return () => {
      clearTimeout(changeModeLoadingTimeout);

      if (changeModeSub.current) {
        changeModeSub.current.unsubscribe();
      }
    };
  }, [sorting]);

  const getRoundedValue = useCallback((val, mode) => {
    if (mode === "OFFLINE" || mode === "STANDBY") return "---";
    if (val === 0) return val;
    if (!val) return "---";
    return Math.round(val);
  }, []);

  const isSchdEnable = useCallback((item) => {
    let schdStatus = item ? item?.scheduleStatus || "" : "";
    return schdStatus.toLowerCase() === "enabled";
  }, []);

  return (
    <>
      <table className="table table-striped theme-table" id={id}>
        <thead>
          <tr>
            {columList.map((item, index) => (
              <th scope="col" key={`device_list_column_${index}`}>
                <div id="listheader" className="sortIconWrapper">
                  <span
                    id="title"
                    // className="clipText"
                    title={item.label}
                    name={item.label}
                  >
                    {item.label}
                  </span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {list.map((item, index) => (
            <tr key={`device_card_${item?.DeviceUUID}`}>
              <td name="device_icon" className="device_icon">
                {index % 2 === 0 ? (
                  <>{Icons.deviceVerticalIcon}</>
                ) : (
                  <>{Icons.deviceHorizontalIcon}</>
                )}
              </td>
              <td name="device_name">
                <Link
                  to={`/device-view/${item?.DeviceUUID}`}
                  className="deviceName"
                  title={`Device Name: ${item?.DeviceName}`}
                >
                  {item?.DeviceName}
                </Link>
              </td>
              <td name="device_location">
                <div
                  className="deviceLocation"
                  title={`Device Location: ${getDeviceLocation(
                    item?.DeviceLocation
                  )}`}
                >
                  {getDeviceLocation(item?.DeviceLocation)}
                </div>
              </td>
              <td
                style={{
                  color: getPPBColor(
                    item?.mode,
                    roundToTwoDec(item?.clo2Value),
                    item?.target
                  ),
                }}
                title={`Device PPB: ${item?.clo2Value}`}
                name="device_ppb"
              >
                <div className="clipText">
                  {valueFinderByModes(item?.mode, "ppb", item?.clo2Value)}
                </div>
              </td>
              <td
                style={{
                  color: cartridgeColor(
                    round5ForCatridge(item?.cartridgeLevel),
                    item?.mode
                  ),
                }}
                title={`Device Cartridge Level: ${valueFinderByModes(
                  item?.mode,
                  "cartridge",
                  item?.cartridgeLevel,
                  true
                )}`}
                name="device_cartridge"
              >
                <div className="clipText">
                  {valueFinderByModes(
                    item?.mode,
                    "cartridge",
                    item?.cartridgeLevel,
                    false
                  )}
                </div>
              </td>
              <td
                title={`Device Temperature: ${item?.temperature}\u00b0C`}
                name="device_temperature"
                className="device_temperature"
              >
                <div
                  className={`clipText ${
                    modeChecker(item?.mode) ? "modeOfflineCartridge" : ""
                  }`}
                >
                  {valueFinderByModes(
                    item?.mode,
                    "temperature",
                    item?.temperature,
                    false
                  )}
                </div>
              </td>
              <td
                title={`Device Humidity: ${valueFinderByModes(
                  item?.mode,
                  "humidity",
                  item?.humidity,
                  true
                )}`}
                name="device_humidity"
                className="device_humidity"
              >
                <div
                  className={`clipText ${
                    modeChecker(item?.mode) ? "modeOfflineCartridge" : ""
                  }`}
                >
                  {valueFinderByModes(
                    item?.mode,
                    "humidity",
                    item?.humidity,
                    false
                  )}
                </div>
              </td>
              <td
                title={`Device Last Updated: ${item?.timeStamp}`}
                name="device_last_update"
                className="last-updated"
              >
                <div>
                  {item?.timeStamp
                    ? formatDateTime(new Date(item?.timeStamp))
                    : "---"}
                </div>
              </td>
              <td>
                <span
                  className={`deviceOta ${
                    item?.mode === "OFFLINE" ? "offline" : "online"
                  }`}
                >
                  {item?.otaStatus === "InProgress" ? (
                    <>{Icons.otaInProgressIcon}</>
                  ) : item?.otaStatus === "UpdateAvailable" ? (
                    <>{Icons.otaAvailableIcon}</>
                  ) : (
                    <></>
                  )}
                </span>
              </td>
              <td>
                {isSchdEnable(item) && (
                  <span
                    className={`deviceEnabledScheduler ${
                      item?.mode === "OFFLINE" ? "offline" : ""
                    }`}
                  >
                    {Icons.deviceSchedulerIsEnabledIcon}
                  </span>
                )}
              </td>
              <td name="device_change_mode" id="device_change_mode">
                <DropDown
                  options={item?.mode === "OFFLINE" ? offlineMode : modeList}
                  value={item?.mode}
                  hideSelectedOption
                  wrapperClass={`${
                    item?.mode === "OFFLINE"
                      ? "modeOfflineDropdownDashboard"
                      : "secondary"
                  }`}
                  identifier={item}
                  autoid={`device_modes_${index}`}
                  onSelection={changeDeviceModeMQTT}
                  name="changemode"
                  alwaysShowIcon={true}
                  disabled={loggedInUserRole === USER_ROLES.viewOnlyUserCorp}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {!list?.length && !isFilterApplied && searchText === "" && !isLoading && (
        <div className="noResultFoundListView d-flex align-items-center justify-content-center">
          <EmptyScreen
            img={Icons.noDeviceOnboarded}
            title={t("no_device_onboarded")}
            desc={t("no_device_onboarded_desc")}
            titleName="noDeviceOnboarded"
            descName="noDeviceOnboarded"
          />
        </div>
      )}
      {!list?.length && isFilterApplied && !isLoading && (
        <div className="noResultFoundListView d-flex align-items-center justify-content-center">
          <EmptyScreen
            img={Icons.noDeviceOnboarded}
            title={t("no_device_found")}
            desc={t("no_device_found_desc")}
            showButton={true}
            BtnTitle={t("resetFilters")}
            BtnTitleId="resetFilters"
            BtnIcon={Icons.resetFilterIcon}
            BtnCTA={() => {
              removeAllFilters();
            }}
            titleName="noFilteredDevice"
            descName="noFilteredDevice"
          />
        </div>
      )}

      {!list?.length && !isFilterApplied && searchText !== "" && !isLoading && (
        <div className="noResultFoundListView d-flex align-items-center justify-content-center">
          <EmptyScreen
            img={Icons.noDeviceOnboarded}
            title={t("no_device_found")}
            desc={t("no_device_found_desc")}
          />
        </div>
      )}
      <ModalComponent
        idName="list_view_dashboard_modal"
        isOpen={isDeviceModeErrorModal}
        onCloseModal={() => setIsDeviceModeErrorModal(false)}
        descriptionText={t("mode_change_error_message")}
      ></ModalComponent>
    </>
  );
};

export default forwardRef(ListView);
